import { Card, Badge } from 'react-bootstrap';
import DepartureStatusIcon from "./DepartureStatusIcon.jsx";

/**
 * Departures Legend - Displays legend for departure status indicators
 */
function DeparturesLegend() {
  return (
    <Card className="legend w-100">
      <Card.Header>
        <h3 className="mb-0">Departure Info & Legend</h3>
      </Card.Header>
      <Card.Body>
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          <Badge className="scheduled"><DepartureStatusIcon status="scheduled" />Scheduled</Badge>
          <Badge className="on-time"><DepartureStatusIcon status="on-time" />On Time*</Badge>
          <Badge className="early"><DepartureStatusIcon status="early" />Early*</Badge>
          <Badge className="delayed"><DepartureStatusIcon status="delayed" />Late*</Badge>
        </div>
        <p>
          Estimated departure times are based on real-time data. The times listed correspond to a bus that is currently on this route.
        </p>
      </Card.Body>
    </Card>
  );
}

export default DeparturesLegend;
